import React, { useEffect, useState } from "react";
import { Form, Button, Table, Spinner, Modal } from "react-bootstrap";

const BASE_URL = 'https://oficinavirtual-solponiente.com/api';

const BuscadorDocumentos = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [resultados, setResultados] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [descargando, setDescargando] = useState(null);
  const [documentoAEliminar, setDocumentoAEliminar] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [eliminando, setEliminando] = useState(false);

  useEffect(() => {
    getUsuarios();
    getDocumentos();
  }, []);

  const handleBuscar = (e) => {
    e.preventDefault();
    const term = textoBusqueda.toLowerCase();
    const usuariosFiltrados = usuarios.filter(
      (usuario) =>
        usuario.Nombre.toLowerCase().includes(term) ||
        usuario.Apellidos.toLowerCase().includes(term) ||
        usuario.Num_Identificacion?.toLowerCase().includes(term)
    );

    const documentosFiltrados = documentos.filter((doc) =>
      usuariosFiltrados.some((usuario) => usuario.UsuarioID === doc.usuario_id)
    );

    const resultadosConUsuarios = documentosFiltrados.map((doc) => {
      const usuario = usuarios.find((user) => user.UsuarioID === doc.usuario_id);
      return { ...doc, usuario };
    });

    setResultados(resultadosConUsuarios);
  };

  const getUsuarios = async () => {
    try {
      const response = await fetch(`${BASE_URL}/usuarios`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setUsuarios(data);
      }
    } catch (error) {
      console.error("Error al hacer la solicitud de usuarios:", error);
    }
  };

  const getDocumentos = async () => {
    try {
      const response = await fetch(`${BASE_URL}/documentos`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setDocumentos(data);
      }
    } catch (error) {
      console.error("Error al hacer la solicitud de documentos:", error);
    }
  };

  // Descarga llamando al endpoint dedicado — sin base64 en memoria
  const handleDownload = async (documentoId, nombreDocumento) => {
    setDescargando(documentoId);
    try {
      const response = await fetch(
        `${BASE_URL}/documentos/${documentoId}/download`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      if (!response.ok) throw new Error("Error al descargar");

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombreDocumento || "documento.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("No se pudo descargar el documento.");
    } finally {
      setDescargando(null);
    }
  };

  const confirmarEliminar = (doc) => {
    setDocumentoAEliminar(doc);
    setShowConfirmDelete(true);
  };

  const cancelarEliminar = () => {
    setDocumentoAEliminar(null);
    setShowConfirmDelete(false);
  };

  const handleDelete = async () => {
    if (!documentoAEliminar) return;
    setEliminando(true);
    try {
      const response = await fetch(
        `${BASE_URL}/documentos/${documentoAEliminar.DocumentoID}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      if (response.ok) {
        setResultados((prev) => prev.filter((d) => d.DocumentoID !== documentoAEliminar.DocumentoID));
        setDocumentos((prev) => prev.filter((d) => d.DocumentoID !== documentoAEliminar.DocumentoID));
      } else {
        alert("No se pudo eliminar el documento.");
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
      alert("No se pudo eliminar el documento.");
    } finally {
      setEliminando(false);
      setShowConfirmDelete(false);
      setDocumentoAEliminar(null);
    }
  };

  return (
    <div>
      <Form onSubmit={handleBuscar}>
        <Form.Group controlId="textoBusqueda">
          <Form.Label>Buscar Documentos por Usuario (nombre, apellidos o DNI/NIE/CIF)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Nombre, apellidos o DNI/NIE/CIF del usuario"
            value={textoBusqueda}
            onChange={(e) => setTextoBusqueda(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="submit" className="mt-3">
          Buscar
        </Button>
      </Form>

      {resultados.length > 0 && (
        <div className="mt-4">
          <h3>Resultados de Documentos</h3>
          <Table striped bordered hover className="table-responsive">
            <thead>
              <tr>
                <th>Nombre del Documento</th>
                <th>Usuario</th>
                <th>Fecha de Subida</th>
                <th>Firmado por Usuario</th>
                <th>Firmado por Admin</th>
                <th>Descargar</th>
                <th>Eliminar</th>
              </tr>
            </thead>
            <tbody>
              {resultados.map((doc) => (
                <tr key={doc.DocumentoID}>
                  <td>{doc.NombreDocumento}</td>
                  <td>
                    {doc.usuario.Nombre} {doc.usuario.Apellidos}
                  </td>
                  <td>{doc.FechaSubida}</td>
                  <td>{doc.FirmadoUser ? "Sí" : "No"}</td>
                  <td>{doc.FirmadoAdmin ? "Sí" : "No"}</td>
                  <td>
                    <Button
                      variant="secondary"
                      size="sm"
                      disabled={descargando === doc.DocumentoID}
                      onClick={() => handleDownload(doc.DocumentoID, doc.NombreDocumento)}
                    >
                      {descargando === doc.DocumentoID ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Descargar"
                      )}
                    </Button>
                  </td>
                  <td>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => confirmarEliminar(doc)}
                    >
                      <i className="bi bi-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      <Modal show={showConfirmDelete} onHide={cancelarEliminar} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar el documento{" "}
          <strong>{documentoAEliminar?.NombreDocumento}</strong>? Esta acción no
          se puede deshacer.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelarEliminar} disabled={eliminando}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDelete} disabled={eliminando}>
            {eliminando ? <Spinner animation="border" size="sm" /> : "Eliminar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BuscadorDocumentos;